import { ViewModel,View } from "binder"
import { IDefaultValueManipulator } from "../defaultValueManipulator";
import  { ClassView } from "./class-view"
import { IMemberContainer } from "../../../dataModelBuilder-viewModel";

export class ClassViewModel extends ViewModel implements IDefaultValueManipulator{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new ClassView();
    }
    public getTypeId(): string {
        return "VM-177AE68F-E99C-46AA-B3EF-B9B72546A7CC"
    }

    setDefaultValue(defaultValue: any): void {
    }
    getDefaultValue():any {
        return null;
    }
    verify(owningClass : IMemberContainer): string[] {
        let result = [];
        return result;
    }

}
